import { memo } from "react";
import { useAppSelector } from "stores";
import store from "stores/interfaces";
import { List } from "@mui/material";

import PanelListItem from "./MarkerListItem";

const PanelList = () => {
  const roomId =
    useAppSelector((state) => store.getAppState(state, "roomId")) || "";
  const markerIds = useAppSelector((state) => {
    return store.getRoomMarkerIds(state, { roomId });
  });

  return (
    <List dense>
      {markerIds.map((markerId) => (
        <PanelListItem key={markerId} markerId={markerId} roomId={roomId} />
      ))}
    </List>
  );
};

export default memo(PanelList);
